import { useState } from 'react';

import { type SegmentFilter, type StudentDataModalProps } from './StudentDataModal';
import { type StudentColumn } from './viewData.columns';

export type StudentDataHandle = Readonly<{
  id: string;
  openAll: () => void;
  openSegment: (segment: SegmentFilter) => void;
  modal: StudentDataModalProps;
}>;

export const useStudentData = (
  id: string,
  title: string,
  columns: readonly StudentColumn[],
  note?: string,
): StudentDataHandle => {
  const [isOpen, setIsOpen] = useState(false);
  const [segment, setSegment] = useState<SegmentFilter | undefined>();

  return {
    id,
    openAll: () => {
      setSegment(undefined);
      setIsOpen(true);
    },
    openSegment: (next) => {
      setSegment(next);
      setIsOpen(true);
    },
    modal: {
      id: `${id}-modal`,
      open: isOpen,
      onClose: () => setIsOpen(false),
      title,
      columns,
      note,
      segment,
      onClearSegment: () => setSegment(undefined),
    },
  };
};
